import { render } from "./ImprimirRecibo.vue?vue&type=template&id=72333180&scoped=true"
import script from "./ImprimirRecibo.vue?vue&type=script&lang=js"
export * from "./ImprimirRecibo.vue?vue&type=script&lang=js"

import "./ImprimirRecibo.vue?vue&type=style&index=0&id=72333180&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72333180"]])

export default __exports__